import { Globe } from "lucide-react";
import { LANGS } from "../i18n";
import { useLang } from "../LanguageContext";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="lang-switcher">
      <Globe size={15} className="text-white/50 mr-1" />
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`text-xs font-medium px-2 py-1 rounded-sm transition-colors ${
            lang === l.code ? "bg-[#E02020] text-white" : "text-white/60 hover:text-white"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};
